import { styled } from '@linaria/react'

export const HeaderToolsContainer = styled('div')`
  height: 100%;
  padding: 0 0 0 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`
